import React, { Component } from "react";
import { Row, Col, Button, Modal, Typography, Form, Input, InputNumber, Select, message, Upload, Checkbox, Spin } from 'antd';

import axios from "axios"
import { getResponseError } from "../../Utils";

const { Title } = Typography;
const { Option } = Select;


class ModalCategorias extends Component {


    constructor(props) {
        super(props);
        this.state = {
            loading: false
        }
    }

    formRef = React.createRef();

    componentDidMount() {
        if (this.props.categoria_id !== undefined) {
            this.getCategoria()
        }
    }

    /**
     * @memberof ModalCategorias
     * @method getCategoria
     * @description Obtiene una Categoria de la DB
     *
     */
    getCategoria = () => {
        this.setState({ loading: true })
        axios.get('/categoria/' + this.props.categoria_id).then(response => {
            let categoria = response.data;
            this.formRef.current.setFieldsValue({
                nombre: categoria.nombre,
                descripcion: categoria.descripcion
            })
        }).catch(error => {
            message.error('Error al obtener la categoría')
            console.log(error)
        }).finally(() => this.setState({ loading: false }))
    }


    /**
     * @memberof ModalCategorias
     * @method onFinish
     * @description Se ejecuta al dar enter al formulario
     * 
     */
    onFinish = (values) => {

        if (this.props.categoria_id) {
            this.update(values)
        } else {
            this.add(values)
        }

    }

    /**
     * @memberof ModalCategorias
     * @method add
     * @description Añade una categoria a la BD
     *
     */
    add = (values) => {
        axios.post('/categorias', values).then(response => {
            message.success('Categoría creada!')
            this.props.onClose()
        }).catch(error => {
            message.error(getResponseError(error.response, 'Error al crear la categoría '))
            console.log(error)
        })
    }

    /**
     * @memberof ModalCategorias
     * @method update
     * @description Actualiza la información de una Categoria
     * 
     */
    update = (values) => {
        this.setState({ loading: true })
        axios.put('/categorias', {
            ...values,
            categoria_id: this.props.categoria_id
        }).then(response => {
            message.success('Categoría actualizada!')
            this.props.onClose()
        }).catch(error => {
            message.error(getResponseError(error.response, 'Error actualizando categoría'))
            console.log(error)
        }).finally(() => this.setState({ loading: false }))
    }


    render() {

        return (
            <Form
                layout="vertical"
                name="form-categoria"
                id="form-categoria"
                ref={this.formRef}
                onFinish={this.onFinish}

            >
                <Spin spinning={this.state.loading}>
                    <Row gutter={[16, 16]}>
                        <Col xs={24}>
                            <Form.Item
                                label="Nombre"
                                name="nombre"
                                rules={[{
                                    required: true,
                                    message: "Ingrese el nombre"
                                }]}
                            >
                                <Input placeholder="Nombre" ></Input>
                            </Form.Item>
                        </Col>

                        <Col xs={24}>
                            <Form.Item
                                label="Descripción"
                                name="descripcion"
                            >
                                <Input.TextArea placeholder="Descripción" rows={4} />
                            </Form.Item>
                        </Col>
                    </Row>
                </Spin>
            </Form>
        )
    }
}



export default function (props) {
    const { visible = false, onClose = () => { }, categoria_id } = props

    return <Modal
        open={visible}
        onCancel={onClose}
        title={categoria_id ? "Editar Categoría" : "Crear Categoría"}
        destroyOnClose={true}
        cancelText="Cancel"
        okText="Save"
        okButtonProps={{ form: 'form-categoria', key: 'submit', htmlType: 'submit' }}
    >
        <ModalCategorias {...props} />
    </Modal>

}